import { render, staticRenderFns } from "./SearchRecipients.vue?vue&type=template&id=266f84ef&"
import script from "./SearchRecipients.vue?vue&type=script&lang=js&"
export * from "./SearchRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266f84ef')) {
      api.createRecord('266f84ef', component.options)
    } else {
      api.reload('266f84ef', component.options)
    }
    module.hot.accept("./SearchRecipients.vue?vue&type=template&id=266f84ef&", function () {
      api.rerender('266f84ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Compose/SearchRecipients.vue"
export default component.exports